import * as config from '@/config.json'

import Loading from 'vue-loading-overlay'
import axios from 'axios'
import PaginationNav from '../../../components/PaginationNav.vue'
import PaginationMobile from '../../../components/PaginationMobile.vue'
import TableSkeleton from '../../../components/TableSkeleton.vue'
import StoreCardSkeleton from '../../../components/StoreCardSkeleton.vue'

export default {
  name: 'SearchSpeech',
  components: {
    Loading,
    PaginationNav,
    PaginationMobile,
    TableSkeleton,
    StoreCardSkeleton
  },
  data: () => {
    return {
      isLoading: false,
      activeTab: 'totem', // 'totem' ou 'site'
      filter: '',
      selectedOption: '',
      option: [
        {
          value: '',
          text: 'Selecione um filtro'
        },
        {
          value: 1,
          text: 'Número do Totem'
        },
        {
          value: 2,
          text: 'Token do Totem'
        }
      ],
      selectedOptionCompany: null,
      optionsCompany: [],
      selectedOptionSite: null,
      optionsSite: [],
      items: [],
      siteItems: [],
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'createdAt',
          label: 'Data'
        },
        {
          key: 'number',
          label: 'Número Totem'
        },
        {
          key: 'fullName',
          label: 'Totem'
        },
        {
          key: 'token',
          label: 'Token Totem'
        },
        {
          key: 'speechDescription',
          label: 'Descrição da Fala'
        },
        {
          key: 'speechText',
          label: 'Texto da Fala'
        },
        {
          key: 'action',
          label: ''
        }
      ],
      siteFields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'createdAt',
          label: 'Data'
        },
        {
          key: 'siteCorporateName',
          label: 'Nome Corporativo'
        },
        {
          key: 'siteName',
          label: 'Nome do Site'
        },
        {
          key: 'speechDescription',
          label: 'Descrição da Fala'
        },
        {
          key: 'speechText',
          label: 'Texto da Fala'
        },
        {
          key: 'action',
          label: ''
        }
      ],
      currentPage: 1,
      perPage: 10,
      pagination: {},
      sitePagination: {},
      paginationRange: 6,
      pagePagination: null,
      isBusy: false,
      permissions: [],
      userPermissions: []
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
      // Reset pagination when switching tabs
      this.currentPage = 1

      // Search in the new tab if filters are set
      if (this.selectedOptionCompany && this.selectedOptionSite) {
        if (tab === 'totem') {
          this.searchSpeech(1)
        } else {
          this.searchSiteSpeech(1)
        }
      }
    },

    handleTabChange(tabIndex) {
      const tabName = tabIndex === 0 ? 'totem' : 'site'
      this.setActiveTab(tabName)
    },

    async clearLocalStoragePage() {
      localStorage.removeItem('currentPageSearchSpeechs')
      localStorage.removeItem('selectedOptionCompanySearchSpeechs')
      localStorage.removeItem('selectedOptionSiteSearchSpeechs')
      localStorage.removeItem('selectedOptionFilterSearchSpeechs')
      localStorage.removeItem('filterSearchSpeechs')
    },

    async redirect(ref) {
      if (ref == 'bot-bound') {
        localStorage.removeItem('redirectBotBound')
        localStorage.setItem('redirectBotBound', '/bot-bounded')
      } else {
        await this.clearLocalStoragePage()
      }

      this.$router.push(ref)
    },

    async navigate(page) {
      if (this.activeTab === 'totem') {
        this.searchSpeech(page)
      } else {
        this.searchSiteSpeech(page)
      }
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async changeFilter() {
      if (this.selectedOption == '' || this.selectedOption == null) {
        if (this.activeTab === 'totem') {
          await this.searchSpeech(this.currentPage)
        } else {
          await this.searchSiteSpeech(this.currentPage)
        }
      }
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsCompany.length == 1) {
            if (!this.selectedOptionCompany) {
              this.selectedOptionCompany = this.optionsCompany[0].value
            }
          }

          if (this.selectedOptionCompany) {
            this.getSitesByCompany(this.selectedOptionCompany)
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsCompany = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByCompany(companyId) {
      const url = `${config.default.urlBase}/sites/company/${companyId}`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.sites = response.data

          this.optionsSite = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsSite.length == 1) {
            if (!this.selectedOptionSite) {
              this.selectedOptionSite = this.optionsSite[0].value
            }
          }

          if (this.selectedOptionSite) {
            if (!this.pagePagination) {
              await this.searchSpeech(this.currentPage)
            } else {
              await this.navigate(this.pagePagination)
            }
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsSite = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }
      }
    },

    // Disparar busca ao trocar empresa/site/filtro quando houver dados mínimos
    async onCompanyChange() {
      this.pagePagination = null
      this.currentPage = 1
      this.selectedOptionSite = null
      if (this.selectedOptionCompany) {
        await this.getSitesByCompany(this.selectedOptionCompany)
      }
    },

    async onSiteChange() {
      this.pagePagination = null
      this.currentPage = 1
      if (this.activeTab === 'totem') {
        await this.searchSpeech(1)
      } else {
        await this.searchSiteSpeech(1)
      }
    },

    buildParams(companyId, siteId, option, page) {
      if (this.selectedOptionCompany != null) {
        let params = new Object()

        if (companyId != null) {
          params.companyId = companyId
        } else {
          return null
        }

        if (siteId != null) {
          params.siteId = siteId
        } else {
          return null
        }

        if (option == 1) {
          params.posNumber = this.filter
        }

        if (option == 2) {
          params.posToken = this.filter
        }

        params.pageSize = this.perPage
        params.page = page

        return params
      } else {
        return null
      }
    },

    clearSiteFilter() {
      this.selectedOptionSite = null
    },

    async searchSpeech(page) {
      this.isBusy = true

      const url = `${config.default.urlBase}/speechs/company/search`
      const params = this.buildParams(this.selectedOptionCompany, this.selectedOptionSite, this.selectedOption, page)

      localStorage.setItem('currentPageSearchSpeechs', page)
      localStorage.setItem('selectedOptionCompanySearchSpeechs', this.selectedOptionCompany)
      localStorage.setItem('selectedOptionSiteSearchSpeechs', this.selectedOptionSite)
      localStorage.setItem('selectedOptionFilterSearchSpeechs', this.selectedOption)
      localStorage.setItem('filterSearchSpeechs', this.filter)

      try {
        const response = await axios({
          url,
          method: 'get',
          params,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isBusy = false

          this.pagination = response.data
          this.pagination.rowsPerPage = this.perPage
          this.pagination.paginationRange = this.paginationRange

          this.items = response.data.items
        }
      } catch (error) {
        console.log({
          error
        })

        this.isBusy = false
        this.isLoading = false

        this.items = []
        this.pagination = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status != 404) {
          await this.$alert(`Ocorreu um erro ao buscar os tipos de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async deleteSpeechBounded(speech) {
      await this.destroySpeechsBounded(speech.item.posSpeechId)
    },

    async deleteSpeechBoundedMobile(item) {
      await this.destroySpeechsBounded(item.posSpeechId)
    },

    async destroySpeechsBounded(speedchId) {
      this.isLoading = true

      const url = `${config.default.urlBase}/companies/speech/${speedchId}/unbound`

      try {
        const response = await axios({
          url,
          method: 'delete',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          await this.$alert(`Vinculo excluído!`, 'Sucesso', 'success')

          this.searchSpeech(this.currentPage)
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        this.items = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao excluir o vinculo da fala com o totem! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    // Novas funções para sites
    async searchSiteSpeech(page) {
      this.isBusy = true

      const url = `${config.default.urlBase}/speechs/sites/search`
      const params = this.buildSiteParams(this.selectedOptionCompany, this.selectedOptionSite, page)

      localStorage.setItem('currentPageSearchSpeechs', page)

      try {
        const response = await axios({
          url,
          method: 'get',
          params,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isBusy = false

          this.sitePagination = response.data
          this.sitePagination.rowsPerPage = this.perPage
          this.sitePagination.paginationRange = this.paginationRange

          this.siteItems = response.data.items
        }
      } catch (error) {
        console.log({ error })

        this.isBusy = false
        this.isLoading = false

        this.siteItems = []
        this.sitePagination = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status != 404) {
          await this.$alert(`Ocorreu um erro ao buscar falas de sites! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    buildSiteParams(companyId, siteId, page) {
      if (this.selectedOptionCompany != null) {
        let params = new Object()

        if (companyId != null) {
          params.companyId = companyId
        } else {
          return null
        }

        if (siteId != null) {
          params.siteId = siteId
        } else {
          return null
        }

        params.pageSize = this.perPage
        params.page = page

        return params
      } else {
        return null
      }
    },

    async deleteSiteSpeechBounded(speech) {
      await this.destroySiteSpeechsBounded(speech.item.siteSpeechId)
    },

    async deleteSiteSpeechBoundedMobile(item) {
      await this.destroySiteSpeechsBounded(item.siteSpeechId)
    },

    async destroySiteSpeechsBounded(siteSpeechId) {
      this.isLoading = true

      const url = `${config.default.urlBase}/speech/site/${siteSpeechId}/unbound`

      try {
        const response = await axios({
          url,
          method: 'delete',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          await this.$alert(`Vínculo do site excluído!`, 'Sucesso', 'success')

          this.searchSiteSpeech(this.currentPage)
        }
      } catch (error) {
        console.log({ error })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao excluir o vínculo da fala com o site! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getPermissions() {
      this.permissions = await JSON.parse(sessionStorage.getItem('permissions'))
      await this.mapUserPermissions(this.permissions)
    },

    async mapUserPermissions(permissions) {
      if (!Array.isArray(permissions)) {
        this.userPermissions = []
        return
      }

      const commands = permissions.filter(item => item.command).map(item => item.command)
      this.userPermissions = commands
    }
  },

  computed: {
    showSelectCompanyMessage() {
      return !this.selectedOptionCompany
    },
    showSelectSiteMessage() {
      return this.selectedOptionCompany && !this.selectedOptionSite
    },
    currentItems() {
      return this.activeTab === 'totem' ? this.items : this.siteItems
    },

    currentPagination() {
      return this.activeTab === 'totem' ? this.pagination : this.sitePagination
    },

    currentFields() {
      return this.activeTab === 'totem' ? this.fields : this.siteFields
    },
    hasBotBoundPermission() {
      return this.userPermissions.includes('bot_bound')
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    this.pagePagination = localStorage.getItem('currentPageSearchSpeechs')
    this.selectedOptionCompany = localStorage.getItem('selectedOptionCompanySearchSpeechs')
    this.selectedOptionSite = localStorage.getItem('selectedOptionSiteSearchSpeechs')
    this.selectedOption = localStorage.getItem('selectedOptionFilterSearchSpeechs')
    this.filter = localStorage.getItem('filterSearchSpeechs') ? localStorage.getItem('filterSearchSpeechs') : ''

    this.activeTab = 'totem'
    this.getCompanies()
    this.getPermissions()
    this.isLoading = false
  }
}
